import { AxiosError, AxiosRequestConfig } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ErrorResponse, SuccessResponse } from 'src/utilities/restApi/common/types/responses';
import { RequestPreviewBulkSupporterAssignment, ResponsePreviewBulkSupporterAssignment } from 'src/utilities/restApi/kanri/types/bulkSupporterAssignment';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

const url = '/shienkankei/preview-bulksupporterassignment';

export const previewBulkSupporterAssignment = async (data: RequestPreviewBulkSupporterAssignment, controller?: AbortController) => {
  const headers = { headers: await getCommonHeaders() };
  const config: AxiosRequestConfig = { ...headers, signal: controller?.signal };

  return new Promise<SuccessResponse<ResponsePreviewBulkSupporterAssignment>>((resolve, reject) => {
    restApi()
      .post<SuccessResponse<ResponsePreviewBulkSupporterAssignment>>(url, data, config)
      .then((response) => {
        resolve(response.data!);
      })
      .catch((error: AxiosError<ErrorResponse>) => {
        reject(error.response?.data);
      });
  });
};
